// src/redux/slices/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, getProfileClient } from "../../Utils/Constants";
import { toast } from "react-toastify";

export const hitGetProfileClientApi = createAsyncThunk("hitGetProfileClientApi", async () => {
  try {
    const config = {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: `${localStorage.getItem("clientToken")}`,
      },
    };
    const url = ApiBaseUrl + getProfileClient;
    const response = await axios.get(url, config);
    return response.data;
  } catch (error) {
    toast.error(error.response.data.message);
    throw error.response.data;
  }
});

const GetProfileClientSlice = createSlice({
  name: "getProfileClientReducer",
  initialState: {
    isLoading: false,
    data: null,
  },
  reducers: {
    clearhitGetProfileClientData: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(hitGetProfileClientApi.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(hitGetProfileClientApi.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(hitGetProfileClientApi.rejected, (state) => {
        state.isError = false;
      });
  },
});

export const { clearhitGetProfileClientData } = GetProfileClientSlice.actions;
export default GetProfileClientSlice.reducer;
